import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixThumbUpIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M14.7936 6.45853L13.8881 10.1891H19.167C19.4481 10.1891 19.7254 10.2545 19.9768 10.3802C20.2283 10.506 20.447 10.6885 20.6157 10.9134C20.7844 11.1383 20.8984 11.3994 20.9487 11.676C20.999 11.9527 20.9842 12.2372 20.9055 12.5071L18.7957 19.7508C18.686 20.127 18.4573 20.4574 18.1438 20.6925C17.8303 20.9276 17.4491 21.0547 17.0572 21.0547H4.8334C4.35311 21.0547 3.89249 20.8639 3.55287 20.5243C3.21326 20.1847 3.02246 19.724 3.02246 19.2438V12C3.02246 11.5197 3.21326 11.0591 3.55287 10.7195C3.89249 10.3799 4.35311 10.1891 4.8334 10.1891H7.33249C7.6694 10.1889 7.99958 10.0947 8.28591 9.91717C8.57224 9.73961 8.80336 9.48571 8.95328 9.18399L12.0771 2.94531C12.5041 2.9506 12.9244 3.05231 13.3066 3.24285C13.6888 3.43338 14.0229 3.70781 14.2841 4.04564C14.5453 4.38347 14.7268 4.77595 14.815 5.19377C14.9033 5.6116 14.8959 6.04395 14.7936 6.45853Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7.5498 10.1875V21.0531"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
